module.exports = __webpack_public_path__ + "static/media/add.b45a582d.svg";